import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Notification, NotificationService } from '@src/app/services/notification.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { slideInDownOnEnterAnimation } from 'angular-animations';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-home-notification',
    standalone: true,
    imports: [CommonModule, SharedModule],
    animations: [slideInDownOnEnterAnimation()],
    templateUrl: './home-notification.component.html',
    styleUrls: ['./home-notification.component.less'],
})
export class HomeNotificationComponent implements OnDestroy, OnInit {
    notificationVisible = false;

    latestMessage: Notification;

    destroy$ = new Subject<void>();

    constructor(private notifService: NotificationService) {}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.notifService.messages$.pipe(takeUntil(this.destroy$)).subscribe(messages => {
            if (messages?.length) {
                this.latestMessage = messages[0];

                const latestNotificationId = localStorage.getItem('socialscan_latest_notification_closed');
                if (latestNotificationId === String(this.latestMessage.id)) {
                    this.notificationVisible = false;
                } else {
                    this.notificationVisible = true;
                }
            }
        });
    }

    closeNotification() {
        localStorage.setItem('socialscan_latest_notification_closed', String(this.latestMessage.id));
        this.notificationVisible = false;
    }
}
